import React, { useState, useEffect } from "react";
import heroImage from "../../hero_image.png";
import "./HeroCarousel.scss";

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: heroImage,
      title: "Fresh Organic Greens",
      subtitle: "Farm to Table • Chemical-Free • Naturally Grown",
      showCTA: true
    },
    {
      image: heroImage,
      title: "Control Blood Sugar Naturally",
      subtitle: "Bitter Gourd • Fenugreek • Spinach • Moringa",
      description: "Rich in fiber and nutrients that help regulate glucose levels",
      showCTA: false
    },
    {
      image: heroImage,
      title: "Manage Blood Pressure",
      subtitle: "Celery • Beetroot • Leafy Greens • Wheatgrass",
      description: "Natural nitrates and potassium support healthy blood pressure",
      showCTA: false
    },
    {
      image: heroImage,
      title: "Boost Gut Health",
      subtitle: "Wheatgrass • Moringa • Cabbage • Aloe Vera",
      description: "Prebiotics and enzymes promote digestive wellness",
      showCTA: false
    },
    {
      image: heroImage,
      title: "Strengthen Your Heart",
      subtitle: "Kale • Arugula • Collard Greens • Spinach",
      description: "Antioxidants and minerals support cardiovascular health",
      showCTA: false
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <div className="hero-carousel">
      <div className="carousel-slides">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`carousel-slide ${index === currentSlide ? "active" : ""}`}
          >
            <img src={slide.image} alt={slide.title} className="slide-image" />
            <div className="slide-overlay">
              <div className="slide-content">
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-subtitle">{slide.subtitle}</p>
                {slide.description && (
                  <p className="slide-description">{slide.description}</p>
                )}
                {slide.showCTA && (
                  <div className="slide-cta">
                    <a href="#products" className="cta-button">Shop Now</a>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="carousel-dots">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentSlide ? "active" : ""}`}
            onClick={() => goToSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroCarousel;
